import { createFileRoute } from '@tanstack/react-router';
import { FeedbackScreen } from '@/features/feedback/FeedbackScreen';

/** /my-feedback is the Feedback page, scrolled to the My feedback list. */
export const Route = createFileRoute('/_app/my-feedback')({
  component: MyFeedbackRoute,
});

function MyFeedbackRoute() {
  return <FeedbackScreen focus="list" />;
}
